import { render, staticRenderFns } from "./CatalogeUpdate.vue?vue&type=template&id=2a488906"
import script from "./CatalogeUpdate.vue?vue&type=script&lang=js"
export * from "./CatalogeUpdate.vue?vue&type=script&lang=js"
import style0 from "./CatalogeUpdate.vue?vue&type=style&index=0&id=2a488906&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports